import { useState, useEffect } from "react";
import {
  Label,
  Select,
} from "../../../assets/StyledComponent/Input/Input.Style";
import { useStore } from "../../../store";
import EnglishDatePicker from "../EnglishDatePicker";
import "../../CanteenReport/styles.css";
import Report from "./Report";
import NepaliDateSelect from "../NepaliDateSelect";
import EnglishDateSelect from "../EnglishDateSelect";
import {
  ALL_COMPANY_GET_FETCH_FAILURE,
  ALL_COMPANY_GET_FETCH_START,
  ALL_COMPANY_GET_FETCH_SUCCESS,
} from "../../../container/Company/types";
import { allCompanyService } from "../../../services/companyService";
const SUserReport = () => {
  const [state, dispatch]: any = useStore();
  const [companyId, setCompanyId] = useState("");

  useEffect(() => {
    dispatch({ type: ALL_COMPANY_GET_FETCH_START });
    allCompanyService()
      .then((res: any) => {
        dispatch({
          type: ALL_COMPANY_GET_FETCH_SUCCESS,
          allCompany: res,
        });
      })
      .catch((err: any) => {
        dispatch({
          type: ALL_COMPANY_GET_FETCH_FAILURE,
          allCompanyError: err,
        });
      });
  }, []);
  return (
    <div className="calenderContainerr">
      <div className="calenderWrapperMain">
        <div className="calenderWrapperr">
          <span className="head">Filters</span>
          <div className="selectDiv">
            <Label
              style={{
                fontWeight: "500",
              }}
            >
              Select Company
            </Label>
            <Select
              style={{
                width: "50%",
                height: "50px",
                marginLeft: "30px",
              }}
              aria-label="Default select example"
              id="#select"
              className="inputTextSelect inputText selectpicker"
              onChange={(e) => setCompanyId(e.target.value)}
            >
              <option disabled value="" selected hidden>
                Select Company
              </option>
              {state.companyReducer?.allCompany?.map((company: any) => {
                return (
                  <option
                    className="option"
                    value={company.company_id}
                    key={company.company_id}
                  >
                    {company.name}
                  </option>
                );
              })}
            </Select>
          </div>
          <EnglishDatePicker companyId={companyId} />
          <NepaliDateSelect companyId={companyId} />
          <EnglishDateSelect companyId={companyId} />
        </div>
        {state.SCmpUserReportReducer?.SCmpUserReport && (
          <Report data={state.SCmpUserReportReducer?.SCmpUserReport} />
        )}
      </div>
    </div>
  );
};

export default SUserReport;
